export enum ViewerStyle {
    Default = 0,
    Neuroglancer = 1
}
